const PostTypesBlockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M0 14v10h10V14zm8 8H2v-6h6zM12 0h12v2H12z" fill="#333" />
    <path fill="#ffd400" d="M12 2h10v2H12z" />
    <path fill="#333" d="M12 6h12v2H12z" />
    <path fill="#ffd400" d="M12 8h10v2H12z" />
    <path fill="#333" d="M12 20h12v2H12z" />
    <path fill="#ffd400" d="M12 22h10v2H12z" />
    <path d="M0 0v10h10V0zm8 8H2V2h6zM12 14h12v2H12z" fill="#333" />
    <path fill="#ffd400" d="M12 16h10v2H12zM2 2h6v6H2zM2 16h6v6H2z" />
  </svg>
);

export default PostTypesBlockIcon;
